import { render, staticRenderFns } from "./PerformanceUnitSnapshotDetail.vue?vue&type=template&id=10d0aa06&scoped=true&"
import script from "./PerformanceUnitSnapshotDetail.vue?vue&type=script&lang=js&"
export * from "./PerformanceUnitSnapshotDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d0aa06",
  null
  
)

export default component.exports